var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gameType == _vm.GameType.ROUNDROBIN)?_c('div',{staticClass:"columns round-robin"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"is-size-3 player-name",staticStyle:{"text-align":"center","height":"500px"}},[_vm._v(" (bye) ")])])
}]

export { render, staticRenderFns }